<template>
  <div class="trustee-council">
    <div class="header flex-cl"><img src="./images/header.png" alt=""></div>
    <div class="content">
      <div class="flex-cl">
        <div class="flex-row">
          <div
            :id="`myTrustee${item.id}`"
            :class="[ item.id == 1 ? 'title-mian flex-row pickItem' : 'title-mian flex-row']"
            v-for="(item, index) in headSculptureList"
            :key="item.id"
            @click="changeBtn(index, item.id)">
            <img :src="require(`./images/${titleAction == index ? item.pitchTitle: item.title}`)" alt="" />
          </div>
        </div>
        <div class="text" v-if="titleAction === index" v-for="(item, index) in headSculptureList" :key="item.title">
          <div><img :src="require(`./images/${item.contentImage}`)" /></div><br />
          <p v-if="item.content1">{{item.content1}}</p>
          <p v-if="item.content2">{{item.content2}}</p>
          <p v-if="item.content3">{{item.content3}}</p><br />
          <p v-if="item.enContent1">{{item.enContent1}}</p>
          <p v-if="item.enContent2">{{item.enContent2}}</p>
          <p v-if="item.enContent3">{{item.enContent3}}</p>
          <p v-if="item.enContent4">{{item.enContent4}}</p>
        </div>
      </div>
    </div>
    <go-top></go-top>
  </div>
</template>

<script>
import goTop from "../../common/go-top.vue";
export default {
  name: "TrusteeCouncil",
  components: {
    goTop
  },
  data(){
    return {
      titleAction: 0,
      headSculptureList: [
        {
          id: 1,
          title: 'title1.png',
          pitchTitle: 'pitch-title1.png',
          contentImage: 'main-title1.png',
          content1: 'Richard Drobnick 负责南加州⼤学备受重视的职业中期MBA项目，是⻢歇尔国际商学院的创始⼈之⼀ 。他曾担任南加州⼤学国际事务副主席 (1994-2005) ，在由45个成员组成的太平洋沿岸⼤学联合组织 (APRU) 中担任⾸席秘书⻓ (1997-2002) 及指导委员成员(1997-2010) 。他在APRU发起了“持续发展及⽓候变化”以及“公共卫⽣”的研究项目(2006-2010)。',
          content2: 'Drobnick对太平洋沿岸经济、 商业问题及美国-太平洋沿岸贸易政策都有深刻⻅地 。他撰写了众多⽂章，是《既⾮盛宴也⾮饥荒： 2000年粮⻝状况》 的联合作者及《⼩公司在全球的竞争》 的联合编辑。 Drobnick是亚洲协会理事、 亚洲协会南加州分会主席， 也是外交关系委员会成员之⼀，曾在⻢来⻄亚志愿参加了联合国维和⾏动 。',
          enContent1: 'Richard Drobnick runs USC’s highly regarded mid-career MBA program and was the founding director of the Marshall School’s Center for International Business.',
          enContent2: 'He served as USC’s inaugural Vice Provost for International Affairs (1994-2005).Drobnick was the inaugural Secretary General (1997-2002) and Steering Committee member (1997-2010) of the Association of Pacific Rim Universities, a group of presidents of 45 leading research universities. He launched APRU’s Pacific Rim research programs on “Sustainability and Climate Change” and “Public Health” (2006-2010).',
          enContent3: 'Drobnick specializes in Pacific Rim economic and business issues and U.S.-Pacific Rim trade policies. He is the author of numerous articles, co-author of Neither Feast nor Famine: Food Conditions to the Year 2000 and co-editor of Small Firms in Global Competition.',
          enContent4: 'Drobnick is an Asia Society Trustee and Chairman of Asia Society Southern California, and also a member of the Council on Foreign Relations. He served as a Peace Corps volunteer in Malaysia。'
        },
        {
          id: 2,
          title: 'title2.png',
          pitchTitle: 'pitch-title2.png',
          contentImage: 'main-title2.png'
        },
        {
          id: 3,
          title: 'title3.png',
          pitchTitle: 'pitch-title3.png',
          contentImage: 'main-title3.png',
          content1: '陈琦伟教授是中国著名的国际金融学家和资本市场专家，其专业代表作有《国际竞争论》、《投资银行学》、《公司金融》，其中《国际竞争论》曾在我国青年学者中首获“孙冶方经济学优秀著作奖”。',
          content2: '国内最早一批将学术理论知识付诸于商业实践的学者型企业家，九十年代初，就把国际通行的企业兼并收购及重组的方法和实践经验引入国内。',
          content3: '通过参与一系列中国企业上市，上市公司收购兼并和重组以及VC和PE投资的案例，陈琦伟带领亚商集团成长为国内享有盛名的资产管理和企业策略服务集团，体现了洞察中国经济金融资本市场主流商业机会的前瞻力。',
          enContent1: 'Founder of “Academy of Asia+ Business”; Vice President of China Venture Capital Association; Director of China Society of Economic Reform; Professor and Doctoral Supervisor of Antai College of Economics & Management, Shanghai Jiao Tong University, and Director of China Venture Capital Research Centre. ',
          enContent2: 'He had also served as an independent director of more than ten financial and real listed top companies, including Haitong Securities Company Limited, Guangzhou Development Group Incorporated and Suzhou Trust.',
          enContent3: 'Dr. Qiwei Chen is a prestigious Chinese financial economist and was awarded the highest prize for Chinese economics research in 1987.'
        },
        {
          id: 4,
          title: 'title4.png',
          pitchTitle: 'pitch-title4.png',
          contentImage: 'main-title4.png'
        },
        {
          id: 5,
          title: 'title5.png',
          pitchTitle: 'pitch-title5.png',
          contentImage: 'main-title5.png'
        },
        {
          id: 6,
          title: 'title6.png',
          pitchTitle: 'pitch-title6.png',
          contentImage: 'main-title6.png'
        },
        {
          id: 7,
          title: 'title7.png',
          pitchTitle: 'pitch-title7.png',
          contentImage: 'main-title7.png'
        }
      ]
      // swiperOptions: { // 轮播插件
      //   effect: 'fade',
      //   height: 754,
      //   // 分页器
      //   pagination: {
      //     el: '.swiper-pagination',
      //     clickable: true,
      //     bulletClass: 'my-bullet',
      //     bulletActiveClass: 'my-bullet-active'
      //   },
      //   direction: 'vertical',// 竖滚，垂直滚动
      //   mousewheel: true,// 鼠标滚动
      //   // loopedSlides: 6, //在loop 模式下使用 slidesPerview:'auto' ，还需使用该参数设置所要用到的loop 个数(一般设置大于可视slide个数2个即可)。
      //   // // 左右按钮
      //   // navigation: {
      //   //   nextEl: '.swiper-button-next', //前进按钮的css选择器或HTML元素。
      //   //   prevEl: '.swiper-button-prev', //后退按钮的css选择器或HTML元素。
      //   //   // hideOnClick: true, //点击slide时显示/隐藏按钮
      //   // },
      //   // autoplay: {
      //   // delay: 3000,
      //   // disableOnInteraction: false
      //   // },
      //   // loop: true,// 从第一个直接滑到最后一个
      //   // slidesPerView: 'auto',
      //   // // 如果需要滚动条
      //   // scrollbar: {
      //   //   el: '.swiper-scrollbar',
      //   //   hide: true, //滚动条是否自动隐藏。默认：false，不会自动隐藏。
      //   //   draggable: true, //该参数设置为true时允许拖动滚动条。
      //   //   snapOnRelease: true, //如果设置为false，释放滚动条时slide不会自动贴合。
      //   //   dragSize: 10, //设置滚动条指示的尺寸。默认'auto': 自动，或者设置num(px)。
      //   // },
      //   //   effect:"coverflow",
      //   //   // height: 722,
      //   //   rewind:true,// 在最后一个Slide 上单击“next”导航按钮（或调用.slideNext()）将滑回到第一个Slide。在第一个Slide 上单击“prev”导航按钮（或调用.slidePrev()）将滑动到最后一个Slide。
      //   //   grabCursor : true,//  时指针会变成手掌形状，拖动时指针会变成抓手形状。
      //   //   setWrapperSize :true,
      //   //   mousewheelControl : true,
      //   //   observeParents:true,
      // },
    }
  },
  methods: {
    handleMouseenter(id){
      const myTrustee = document.getElementById(`myTrustee${id}`);
      if (myTrustee) {
        myTrustee.classList.add('pickItem');
        this.titleAction = id-1;
      }
      this.headSculptureList.map(item => {
        const otherElement = document.getElementById(`myTrustee${item.id}`);
        if(item.id !== id){
          otherElement.classList.remove('pickItem');
        }
      })
    },
    changeBtn(index, id) {
      this.titleAction = index;
      this.handleMouseenter(id);
    }
  }
}
</script>

<style scoped>
.trustee-council{
  flex: 1;
  width: 100vw;
  min-width: 1200px;
  background: #FFFFFF;
}
.trustee-council .header{
  width: 100%;
}
.trustee-council .content {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 78px;
}
.trustee-council .flex-row{
  display: flex;
  flex-flow: row;
}
.trustee-council .flex-cl{
  display: flex;
  flex-flow: column;
}
.trustee-council .title-mian{
  width: 163px;
  height: 79px;
  align-items: center;
  justify-content: center;
  background: #FFFFFF;
  border: 1px solid #ECEDEF;
  border-right: 0;
  box-sizing: border-box;
}
.trustee-council .title-mian:first-child{
  width: 230px;
}
.trustee-council .title-mian:last-child{
  border-right: 1px solid #ECEDEF;
}
.trustee-council .pickItem{
  background: #003B83;
  border: #003B83;
}
.trustee-council .content .text{
  flex: 1;
  /*height: 607px;*/
  box-sizing: border-box;
  font-family: Source Han Sans CN;
  font-size: 16px;
  color: #666666;
  text-align: left;
  line-height: 27px;
  padding-top: 23px;
}
</style>



// WEBPACK FOOTER //
// src/components/trusteeCouncil/TrusteeCouncil.vue